export default __webpack_public_path__ + "static/media/icon_linkin.9d577b58.svg";